import { Button } from '@willow/shared-web';

import { CONTINUE, LIMITED_BODY, LIMITED_CAPTION, LIMITED_FOOTER, LIMITED_TITLE } from './findPortalCopy';
import { FindPortalLayout } from './FindPortalLayout';

import s from './FindPortal.module.scss';

interface Props {
  remainingSeconds: number;
}

const formatCountdown = (totalSeconds: number): string => {
  const safe = Math.max(0, totalSeconds);
  const hours = Math.floor(safe / 3600);
  const minutes = String(Math.floor((safe % 3600) / 60)).padStart(2, '0');
  const seconds = String(safe % 60).padStart(2, '0');
  return hours > 0 ? `${hours}:${minutes}:${seconds}` : `${minutes}:${seconds}`;
};

export const LimitedScreen = ({ remainingSeconds }: Props) => (
  <FindPortalLayout
    testId="find-portal-screen-limited"
    documentTitle={LIMITED_TITLE}
    title={LIMITED_TITLE}
    description={LIMITED_BODY}
  >
    <div className={s.infoBox}>
      <div className={s.countdown} data-testid="find-portal-countdown">
        {formatCountdown(remainingSeconds)}
      </div>
      <div className={s.countdownCaption}>{LIMITED_CAPTION}</div>
    </div>
    <Button
      size="lg"
      className="w-100"
      innerClassName="justify-content-center"
      data-testid="find-portal-continue"
      disabled
    >
      {CONTINUE}
    </Button>
    <p className={s.note}>{LIMITED_FOOTER}</p>
  </FindPortalLayout>
);
